import { Controller as BaseController } from "@hotwired/stimulus"

export class Controller extends BaseController {
  static targets = ["form", "submit", "checkbox"]

  connect() {
    this.toggleSubmit()
  }

  check() {
    this.syncHiddenInputs()
    this.toggleSubmit()
  }

  syncHiddenInputs() {
    this.formTarget
      .querySelectorAll('input[name="production_quote_ids[]"]')
      .forEach((input) => input.remove())

    for (const checkbox of this.checkboxTargets) {
      if (checkbox.checked) this.addHiddenInput(checkbox.value)
    }
  }

  addHiddenInput(value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "production_quote_ids[]"
    input.value = value
    this.formTarget.append(input)
  }

  toggleSubmit() {
    const anyChecked = this.checkboxTargets.some((checkbox) => checkbox.checked)

    if (anyChecked) {
      this.submitTarget.removeAttribute("disabled")
    } else {
      this.submitTarget.setAttribute("disabled", "disabled")
    }
  }
}
